export default __webpack_public_path__ + "static/media/agm-concept-logo-rgb.f3abc9e4.png";